export const extractActionMeta = ({ type, meta: { blend = {} } = {} }) => ({
  id: blend.key || type,
  parent: blend.parent || blend.key || type,
});
